import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-ashmtcontact',
  templateUrl: './ashmtcontact.component.html',
  styleUrls: ['./ashmtcontact.component.scss']
})
export class AshmtcontactComponent implements OnInit {

  constructor() { }

    ngOnInit(): void {
        window.scrollTo(0, 0);
    }

}
